import { render, staticRenderFns } from "./indexSituacionesPersonales.vue?vue&type=template&id=384822da&scoped=true&"
import script from "./indexSituacionesPersonales.vue?vue&type=script&lang=js&"
export * from "./indexSituacionesPersonales.vue?vue&type=script&lang=js&"
import style0 from "./indexSituacionesPersonales.vue?vue&type=style&index=0&id=384822da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384822da",
  null
  
)

export default component.exports